const colors = {
    base_colors: ['#5abee4', '#89ce41', '#ff9e13', '#63146b', '#e75953'],
    color_groups: [
        ["#5abee4","#76c9e9","#92d4ed","#aedff2","#4b9ebd","#3b7d96","#2c5d70","#1d3d49"],
        ["#89ce41","#9dd661","#b1df82","#c5e7a2","#72ab36","#5a882b","#436520","#2c4215"],
        ["#ff9e13","#ffae3b","#ffbf63","#ffcf8b","#d48310","#a8680d","#7d4d09","#523306"],
        ["#63146b","#7e3c84","#98649d","#b38cb6","#521159","#410d47","#310a34","#200622"],
        ["#e75953","#eb7570","#ef918d","#f3aeab","#c04a45","#983b37","#712c29","#4a1c1b"],
        ["#7F5197","#A07DB1","#BFA8CC","#DFD3E5","#572A79","#501E6A","#411957","#331444"]
    ],
    debt_management_colors: ["#4b9ebd", "#410d47"],
    expresswizard_colors: ['#4591ad', '#5fbfe2', '#b7ecff', '#7F5197', '#A07DB1'],
    breakdown_colors: ['#5abee4', '#2eaddd', '#3b7d96', '#2c5d70', '#7e3c84', '#63146b', '#521159', '#410d47']
}

export var base_colors = colors.base_colors
export var color_groups = colors.color_groups
export var debt_management_colors = colors.debt_management_colors
export var expresswizard_colors = colors.expresswizard_colors
export var breakdown_colors = colors.breakdown_colors

export default colors